import GaiaIcon from '@gaia/icons/GaiaIcon';
import {useUser} from '@gaia/stores/user';
import theme from '@gaia/theme';
import {coordinatesToUsersFormat} from '@gaia/utils/formatters';
import {IconButton, Menu, MenuItem} from '@mui/material';
import {useEffect, useState} from 'react';

import CopyCoordinates from './CopyCoordinates';
import WaypointStats from './WaypointStats';
import WeatherSummary from './Weather/WeatherSummary';

function OverflowMenu({coordinates}: {coordinates: string}) {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const openOverflowMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const closeOverflowMenu = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                color='primary'
                aria-label='More actions'
                aria-controls='overflowMenu'
                aria-haspopup='true'
                onClick={openOverflowMenu}
                style={{
                    padding: theme.spacing(1),
                }}
                size='large'
            >
                <GaiaIcon name='more' />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                id='overflowMenu'
                open={Boolean(anchorEl)}
                onClose={closeOverflowMenu}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <MenuItem disableGutters style={{padding: 0}} onClick={closeOverflowMenu}>
                    <CopyCoordinates actionMenuButton coordinates={coordinates} />
                </MenuItem>
            </Menu>
        </>
    );
}

export default function MarkedLocation({
    interaction,
    onInteractionChange,
    onSidebarChange,
    sidebar,
}: {
    interaction: InteractionState;
    onInteractionChange: React.Dispatch<React.SetStateAction<InteractionState>>;
    onSidebarChange: React.Dispatch<React.SetStateAction<SidebarState>>;
    sidebar: SidebarState;
}) {
    const {coordinateFormat} = useUser();

    // Remove the marked location icon when unmounting
    useEffect(() => {
        return () => {
            onInteractionChange((nextInteraction) => ({
                ...nextInteraction,
                markedLocation: undefined,
            }));
        };
    }, [onInteractionChange]);

    if (interaction.type !== 'normal' || !interaction.markedLocation) return null;

    const coordinates = interaction.markedLocation.toArray();
    const formattedCoordinates = coordinatesToUsersFormat(coordinates, coordinateFormat);

    return (
        <div
            style={{
                padding: theme.spacing(2),
                borderBottom: `1px solid ${theme.palette.divider}`,
            }}
        >
            <WaypointStats
                compact
                title={'Marked Location'}
                waypoint={{
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Point',
                        coordinates,
                    },
                }}
                action={<OverflowMenu coordinates={formattedCoordinates} />}
            />
            <WeatherSummary
                coordinates={coordinates}
                onSidebarChange={onSidebarChange}
                sidebar={sidebar}
                style={{marginTop: theme.spacing(1)}}
            />
        </div>
    );
}
